"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callOnlyOnce = exports.executed = exports.sanitizeMetricFragment = exports.urlToMetricPath = void 0;
function urlToMetricPath(url) {
    return sanitizeMetricFragment(url.hostname + url.pathname);
}
exports.urlToMetricPath = urlToMetricPath;
// so graphene metrics can all be like network.*.response.200
// over needing to support network.*.*.response.200 as well
function sanitizeMetricFragment(fragment) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return
    return fragment.replaceAll(".", "_");
}
exports.sanitizeMetricFragment = sanitizeMetricFragment;
exports.executed = new Set();
const callOnlyOnce = (callback, key) => {
    if (!exports.executed.has(key)) {
        exports.executed.add(key);
        callback();
    }
};
exports.callOnlyOnce = callOnlyOnce;
//# sourceMappingURL=utils.js.map